import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['alert', 'btnSendMail'];
  static values = {
    available: { type: Number, default: 0 },
    memberCount: { type: Number, default: 0 }
  };

  sendNewScoutMail() {
    let isOverLimit = this.memberCountValue > this.availableValue;
    isOverLimit ? this.showNoticeAlert() : this.hideNoticeAlert();
    this.disabledBtnSendMail(isOverLimit);
  }

  sendAgainScoutMail() {
    this.hideNoticeAlert();
    this.disabledBtnSendMail();
  }

  hideNoticeAlert() {
    if (!this.hasAlertTarget) return;
    this.alertTarget.classList.add('d-none');
  }

  showNoticeAlert() {
    if (!this.hasAlertTarget) return;
    this.alertTarget.classList.remove('d-none');
  }

  disabledBtnSendMail(disabled = false) {
    if (!this.hasBtnSendMailTarget) return;
    this.btnSendMailTarget.disabled = disabled;
  }
}
